/*
 * Live dispatch status for snippets/shipment-countdown-timer.liquid.
 * Orders placed on a weekday before the cut-off hour (Swedish/Danish time, same time zone) ship the same day;
 * otherwise they ship on the next weekday. Public holidays are not taken into account.
 */
(function () {
  if (window.customDispatchLoaded) return;
  window.customDispatchLoaded = true;

  var partsFormatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Copenhagen',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hourCycle: 'h23'
  });

  // Current weekday (0 = Sunday) and seconds since midnight in Denmark.
  function nowInDenmark() {
    var parts = {};
    partsFormatter.formatToParts(new Date()).forEach(function (part) {
      parts[part.type] = Number(part.value);
    });
    return {
      weekday: new Date(Date.UTC(parts.year, parts.month - 1, parts.day)).getUTCDay(),
      seconds: parts.hour * 3600 + parts.minute * 60 + parts.second
    };
  }

  function isWorkday(weekday) {
    return weekday >= 1 && weekday <= 5;
  }

  function weekdayName(weekday, locale) {
    // 7 January 2024 was a Sunday, so day 7 + weekday lands on the wanted weekday.
    return new Intl.DateTimeFormat(locale, { weekday: 'long', timeZone: 'UTC' })
      .format(new Date(Date.UTC(2024, 0, 7 + weekday)));
  }

  function statusHtml(el) {
    var text = el.dataset;
    var cutoff = Number(text.cutoffHour) * 3600;
    var now = nowInDenmark();

    if (isWorkday(now.weekday) && now.seconds < cutoff) {
      var minutesLeft = Math.ceil((cutoff - now.seconds) / 60);
      var hours = Math.floor(minutesLeft / 60);
      var minutes = minutesLeft % 60;
      var time = hours > 0
        ? text.textHoursMinutes.replace('[hours]', hours).replace('[minutes]', minutes)
        : text.textMinutes.replace('[minutes]', minutes);
      return text.textToday.replace('[time]', time);
    }

    var daysAhead = 1;
    while (!isWorkday((now.weekday + daysAhead) % 7)) daysAhead++;
    var day = daysAhead === 1
      ? text.textTomorrow
      : weekdayName((now.weekday + daysAhead) % 7, text.locale);
    return text.textNextDay.replace('[day]', day);
  }

  function update() {
    document.querySelectorAll('[data-custom-dispatch]').forEach(function (el) {
      var status = el.querySelector('[data-custom-dispatch-status]');
      status.innerHTML = statusHtml(el);
      status.hidden = false;
    });
  }

  update();
  setInterval(update, 30000);
})();
